<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Manage Exams</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
                <p class="text-muted">Exam marks reporting and result declaration</p>
            <display-class-section-exam />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayClassSectionExam from '@/components/bosemexam/manage/Display/index'

export default {
  components: {
    DisplayClassSectionExam,
  },
  data: function() {
    return {
      loading: false,
    }
  },
  methods: {
    handleBackButton() {
      this.$router.push({ name: 'manage_exams' })
    },
  },
}
</script>
